import Character from './Character';
import Sc2Character from './Sc2Character';

class CharacterSerializer {
    static serialize(character) {
        if (character instanceof Character && typeof character.constructor.serialize === 'function') {
            return character.constructor.serialize(character);
        } else {
            throw new Error('Serialize character failed.');
        }
    }

    static deserialize(jsonObj) {
        const className = jsonObj.className;

        switch (className) {
            case Sc2Character.className:
                return Sc2Character.deserialize(jsonObj);
            default:
                throw new Error('Deserialize character failed.');
        }
    }
}

export default CharacterSerializer;
